import Entity from '../entity'

export default class CouponCourt extends Entity<number>{
    court:any;
    coupon:any;
    courtId:0;
    couponId:0
}
